import Axios from 'axios';
import qs from 'qs';
import ShowAlert from '@/pages/components/dialog/alert';
const axios = Axios.create();
axios.defaults.timeout = 10000;
console.log(`========API_ROOT:${API_HOST}========`);
export const API_ROOT = API_HOST;//来源webpack.api.js

let Modal = {
  error: (options) => {
    ShowAlert({ label: options.title, text: `${options.content}` });
  },
};

let logout;

export const setLogout = (fn) => {
  logout = fn;
};

let TOKEN='';
export function LOGOUT(){
  localStorage.removeItem('token');
  TOKEN='';
}
export function SET_TOKEN(token){
  localStorage.setItem('token',token);
  TOKEN=token
}
export function GET_TOKEN(){
  return TOKEN;
}
export function IS_LOGIN(){
  if(!TOKEN){
    TOKEN= localStorage.getItem('token');
  }
  return TOKEN||false;
}



axios.interceptors.request.use(function (config) {
  const header = { 'X-Requested-With': 'XMLHttpRequest' };
  if (config.headers) {
    config.headers = { ...config.headers, ...header };
  } else {
    config.headers = header;
  }

  // 在发送请求之前做些什么
  return config;
});

/**
 * 统一拦截异常消息弹屏报错处理
 * 如果希望某条消息不拦截，可以再发送消息时带上 noInterceptors:true|'all'
 */
axios.interceptors.response.use(
  function (response) {
    if (response.config.noInterceptors) {
      return response;
    }

    if (Number(response.data.code) !== 0) {
      console.log(`${JSON.stringify(response.data)}`);
      Modal.error({ title: `注意`, content: `${response.data.msg}(${response.data.code})` });
    }
    return response;
  },
  function (error) {
    if(!error||!error.response){
      Modal.error({
        title: `请重试`,
        content: `日月有期，还有山海和四季`,
      });
      return null;
    }

    if (error?.response?.config?.noInterceptors === 'all') {
      return Promise.reject(error.response);
    }
    // jwt失效
    if (error.response?.status === 401) {
      LOGOUT();
      if(logout)logout();
      return;
    } else if (error.response?.status === 403) {
      Modal.error({
        title: '提示',
        content: `${error.response.data.msg}`,
      });
      return;
    }
    Modal.error({
      title: `网络错误${error.response?.status}`,
      content: `${error.response.config.url}`,
    });
    return null;
  }
);

let buffer = {};
export async function GET_DEFAULT(url, param, options) {
  if (param) param = qs.stringify(param, { arrayFormat: 'indices' });
  let now = Date.now();

  let bufferItem;
  if (options?.ttl) {
    if (buffer[url]) {
      bufferItem = buffer[url];
      if (bufferItem.param == param && now <= bufferItem.endTime) {
        return bufferItem?.response?.data || null;
      }
    }
  }
  let response = await axios({
    method: 'GET',
    url: param ? `${url}?${param}` : url,
    ...options,
  });

  if (options?.ttl) {
    if (!buffer[url]) {
      buffer[url] = {};
    }
    buffer[url].param = param;
    let ttl = options.ttl === true ? 1000 * 2 : options.ttl;
    buffer[url].endTime = Date.now() + ttl;
    buffer[url].response = response;
  }

  return response && response.data ? response.data : null;
}
export async function GET_DEFAULT_CROSS(url, param) {
  if (param) param = qs.stringify(param, { arrayFormat: 'indices' });

  let response = await axios({
    method: 'GET',
    xsrfCookieName: '',
    xsrfHeaderName: '',
    withCredentials: true,
    url: param ? `${url}?${param}` : url,
  });
  return response && response.data ? response.data : null;
}
export async function POST_DEFAULT(url, params, method, options) {
  let data = params;
  // if (params) params = qs.stringify(params, { arrayFormat: 'indices' });
  // if (typeof params === 'string') {
  //   data = params;
  // } else {
  //   data = { ...params };
  // }

  let response = await axios({
    method: method || 'POST',
    url: url,
    data,
    ...options,
    // headers: { 'content-type': 'application/x-www-form-urlencoded' },
  });
  return response && response.data ? response.data : null;
}
export async function PUT_DEFAULT(url, params, options) {
  return POST_DEFAULT(url, params, 'PUT', options);
}
export async function DELETE_DEFAULT(url, params, options) {
  return POST_DEFAULT(url, params, 'DELETE', options);
}
export async function POST_DEFAULT_CROSS(url, params) {
  let data = {};
  // if (params) params = qs.stringify(params, { arrayFormat: 'indices' });

  if (typeof params === 'string') {
    data = params;
  } else {
    data = { ...params };
  }
  let response = await axios({
    method: 'POST',
    url: url,
    xsrfCookieName: '',
    xsrfHeaderName: '',
    withCredentials: true,
    data,
  });

  return response && response.data ? response.data : null;
}
